export const OAuthSettings = {
  appId: 'cb4016c8-023d-4538-8815-b3e687827cf3',
  scopes: [
    "user.read",    
  ]
};